<template>
  <SfModal v-if="showModal" size="xs" @close="closeModal">
    <template #title>
      {{ title }}
    </template>

    <template #body>
      <div for="all-periods" class="sf-level sf-level-between sf-below-1">
        <label class="sf-form-check sf-form-check-rounded sf-inline-block">
          <input v-model="allPeriods" type="radio" value="true" />
          <span class="sf-form-check-content sf-level">
            <span class="sf-form-check-indicator" />
            <span>{{ allPeriodsLabel }}</span>
          </span>
        </label>
      </div>
      <div for="all-periods" class="sf-level sf-level-between sf-below-1">
        <label
          for="this-and-following-periods"
          class="sf-form-check sf-form-check-rounded sf-inline-block"
        >
          <input
            id="this-and-following-periods"
            v-model="allPeriods"
            type="radio"
            value="false"
          />
          <span class="sf-form-check-content sf-level">
            <span class="sf-form-check-indicator" />
            <span>{{ thisAndFollowingPeriodsLabel }}</span>
          </span>
        </label>
      </div>
    </template>

    <template #footer>
      <SfButtonDs
        variant="danger"
        data-heap="remove-pinned-message-confirm"
        :disabled="allPeriods === null"
        @click="confirm"
      >
        {{ I18n.t('common.remove') }}
      </SfButtonDs>
      <SfButtonDs data-heap="remove-pinned-message-cancel" @click="closeModal">
        {{ I18n.t('common.cancel') }}
      </SfButtonDs>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import { SfModal } from '@app/shared/vue/components/sf-modal'

export default {
  name: 'PinnedMessageRemovalModal',
  components: { SfModal, SfButtonDs },
  data() {
    return {
      showModal: true,
      allPeriods: null,
    }
  },
  computed: {
    title() {
      return I18n.t('communication.pinned_message_removal_modal.title')
    },
    allPeriodsLabel() {
      return I18n.t('communication.pinned_message_removal_modal.all_periods')
    },
    thisAndFollowingPeriodsLabel() {
      return I18n.t(
        'communication.pinned_message_removal_modal.this_and_following_periods'
      )
    },
  },
  methods: {
    openModal({ onConfirm }) {
      this.showModal = true
      this.onConfirm = onConfirm
    },
    closeModal() {
      this.showModal = false
    },
    confirm() {
      this.onConfirm(this.allPeriods === 'true')
      this.closeModal()
    },
  },
}
</script>
